import { analyticsManager } from './AnalyticsManager';
import analyticsPlugin from './AnalyticsPlugin';
import initialState from '@/InitialState';
const plugins = [];

if (initialState.internalAnalyticsTrackingEnabled) {
    plugins.push(analyticsPlugin({}));
}

const analytics = analyticsManager({
    plugins,
});

export default analytics;
